import { useReduxState } from 'hooks';
import { Dropdown } from 'components/common/dropdown';
import { Icon } from 'components/common/icons';

import type { ButtonCategory, ButtonSize } from 'components/common/Button';
import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  align?: string;
  alignVertical?: string;
  buttonStyle?: React.CSSProperties;
  category?: ButtonCategory;
  children: React.ReactNode;
  dropdownStyle?: React.CSSProperties;
  icon?: IconProp;
  label?: string;
  notificationIconColor?: string;
  renderAsFixed?: boolean;
  renderInPortal?: boolean;
  size?: ButtonSize;
  showNotificationIcon?: boolean;
  style?: React.CSSProperties;
  styleContentButtons?: boolean;
  tooltip?: string;
}

const MoreOptions = ({
  align,
  alignVertical,
  buttonStyle = {},
  category,
  children,
  dropdownStyle,
  icon,
  label,
  notificationIconColor,
  renderAsFixed,
  renderInPortal,
  size,
  showNotificationIcon,
  style,
  styleContentButtons,
  tooltip
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <Dropdown
      align={align as 'left' | 'right'}
      alignVertical={alignVertical as 'top' | 'bottom'}
      category={category}
      before={
        <>
          <Icon icon={icon || 'ellipsis-h'} />
          {showNotificationIcon ? <div className="notification-icon" /> : null}
        </>
      }
      buttonStyle={{
        borderRadius: theme.buttonBorderRadius,
        margin: '-2px 0',
        padding: '6px 0',
        textAlign: 'center',
        width: 30,
        height: 30,
        ...buttonStyle
      }}
      dropdownStyle={dropdownStyle}
      label={label || messages.commonShowMoreOptions}
      renderAsFixed={renderAsFixed}
      renderInPortal={renderInPortal}
      size={size}
      style={style}
      styleContentButtons={styleContentButtons}
      tooltip={tooltip}
    >
      {children}

      <style jsx>{`
        .notification-icon {
          background-color: ${notificationIconColor || theme.dangerColor};
          border-radius: 10px;
          height: 6px;
          position: absolute;
          top: 4px;
          right: 3px;
          width: 6px;
        }
      `}</style>
    </Dropdown>
  );
};

export default MoreOptions;
